// routes/routes.tsx
import routesConfig from '../config/routes.json';
import UserHome from '../pages/user/UserHome';
import AdminHome from '../pages/admin/AdminHome';
import Login from '../pages/auth/Login';
import Signup from '../pages/auth/Signup';
import AuthLayout from '../pages/auth/Index';
import DashboardLayout from '../pages/admin/Dashboard';
import ProtectedRoute from './protectedRoute';
import MembersView from '../pages/admin/MembersView/MembersView';
import type { RouteObject } from 'react-router-dom';
import FinishSignUpPage from '../pages/auth/FinishSignUpPage';
import SetupProfilePage from '../pages/user/SetupProfile';
import LayersList from '../pages/admin/Layers/LayerList';
import LayerCreate from '../pages/admin/Layers/LayerCreate';
import NotFoundPage from '../pages/NotFoundPage';
import LayerPreview from '../pages/admin/Layers/LayerPreview';
import TemplatePreview from '../pages/admin/Template/TemplatePreview';
import TemplatesList from '../pages/admin/Template/TemplatesList';
import CreateTemplate from '../pages/admin/Template/CreateTemplate';
import TryItOut from '../pages/admin/TryOut/TryOutLayout';
import MembersViewProfile from '../pages/admin/MembersView/viewMemberProfile';
import UserViewProfile from '../pages/user/ViewProfile/ViewProfile';
import EditProfilePage from '../pages/user/ViewProfile/EditProfile';
import AwaitingConfirmationPage from '../pages/auth/AwaitingConfirmation';
import PaymentList from '../pages/admin/Payment/PaymentList';
import CreateAdministratorsComponent from '../pages/admin/Administrator/CreateAdminComponent'
import type { ComponentType, ReactElement } from 'react';
import ForgotPasswordComponent from '../pages/auth/ForgotPassword';
import ViewReport from '../pages/admin/reports/ViewReport';
import EditReport from '../pages/admin/reports/EditReport';
import UpdateReport from '../pages/admin/reports/UpdateReport';
import AnnexureListView from '../pages/admin/Annexure/AnnexureListView';
import AnnexureForm from '../pages/admin/Annexure/AnnexureForm';
import AnnexureView from '../pages/admin/Annexure/AnnexureView';
import OnBoardPage from '../pages/user/onboarding';
import AccessReportPage from '../pages/user/AccessReport'
import SetupPassword from '../pages/auth/SetupPassword';
import ViewRecipts from '../pages/user/ViewProfile/ViewRecipt';
import ChangePasswordComponent from '../pages/auth/ChangePassword'
import UnsubscribePageComponent from '../pages/user/unSubscribe';


const componentMap: Record<string, ComponentType<any>> = {
  Home: UserHome,
  UserViewProfile: UserViewProfile,
  AccessReport:AccessReportPage,
  OnBoardPage,
  ViewRecipts,
  EditProfile:EditProfilePage,
  AdminHome: AdminHome,
  ReportView: ViewReport,
  ReportEdit:EditReport,
  ReportUpdate:UpdateReport,
  Login: Login,
  Signup: Signup,
  AuthLayout: AuthLayout,
  ForgotPassword:ForgotPasswordComponent,
  MembersView: MembersView,
  AwaitEmail: AwaitingConfirmationPage,
  FinishSignup: FinishSignUpPage,
  SetupProfile: SetupProfilePage,
  LayersList: LayersList,
  LayerCreate: LayerCreate,
  LayerPreview: LayerPreview,
  TemplatePreview: TemplatePreview,
  TemplatesList: TemplatesList,
  CreateTemplate: CreateTemplate,
  NotFoundPage: NotFoundPage,
  TryOut: TryItOut,
  Admin:CreateAdministratorsComponent,
  MembersViewProfile: MembersViewProfile,
  AnnexureListView,
  AnnexureForm,
  AnnexureView,
  PaymentList:PaymentList,
  SetupPassword:SetupPassword,
  ChangePassword:ChangePasswordComponent,
  UnsubscribePage:UnsubscribePageComponent


};

const layoutMap: Record<string, (children: ReactElement) => ReactElement> = {
  Dashboard: (children) => <DashboardLayout>{children}</DashboardLayout>,
};

/**
 * Recursively maps a JSON route config into a RouteObject
 */
function mapRoute(route: any): RouteObject {
  const Comp = componentMap[route.element];

  let element: ReactElement;
  if (Comp) {
    element = <Comp />;
  } else {
    // Fallback for unknown element names — render an empty fragment and warn
    console.warn('[routes] Unknown route element', route.element, 'for path', route.path);
    element = <></>;
  }

  if (route.layout && layoutMap[route.layout]) {
    element = layoutMap[route.layout](element);
  }

  if (route.role) {
    element = <ProtectedRoute role={route.role}>{element}</ProtectedRoute>;
  }

  return {
    path: route.path,
    element,
    children: route.children ? route.children.map(mapRoute) : undefined,
    index: route.index ? true : undefined,
  };
}

const appRoutes: RouteObject[] = routesConfig.map(mapRoute);
export default appRoutes;
